<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formsearch"
            :model="formsearch"
            class="queryform_div"
            label-width="200px"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('desc.customerName')">
                  <el-input
                    size="small"
                    v-model="formsearch.custName"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('desc.airCompressionStation')">
                  <el-input
                    size="small"
                    v-model="formsearch.keyWord"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                <el-button @click="getTableList" type="primary" size="small">{{
                  $t("button.query")
                }}</el-button>
                <el-button @click="resetKeyword" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <template>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="showDialog(true)"
              style="margin-bottom: 10px"
              v-show="hasCreateAuth"
              >{{ $t("button.addAirCompressionStation") }}</el-button
            >
            <div class="tableDiv">
            <el-table
              :data="tableData1"
              stripe
              style="width: 100%"
              :empty-text="$t('desc.noData')"
            >
              <el-table-column
                type="index"
                :label="$t('title.serialNumber')"
                width="60"
              >
              </el-table-column>
              <el-table-column
                prop="customerName"
                :label="$t('desc.customerName')"
                min-width="200px"
              >
              </el-table-column>
              <el-table-column
                prop="stationName"
                :label="$t('desc.airCompressionStation')"
                min-width="150px"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                :label="$t('title.airCompressionStationAddress')"
                min-width="200px"
              >
              </el-table-column>

              <el-table-column
                :label="$t('title.operate')"
                width="110"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    :title="$t('button.update')"
                    circle
                    size="mini"
                    v-show="hasUpdateAuth"
                    @click="showEditDialog(true, scope.row.id)"
                  ></el-button>
                  <template>
                    <el-popconfirm
                      placement="top"
                      :confirmButtonText="$t('button.delete')"
                      :cancelButtonText="$t('button.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('title.confirmDelete')"
                      @confirm="deleteDeviceStation(scope.row.id)"
                    >
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        :title="$t('button.delete')"
                        circle
                        size="mini"
                        slot="reference"
                        v-show="hasDeleteAuth"
                      ></el-button>
                    </el-popconfirm>
                  </template>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <station-dialog
      ref="stationAddRef"
      :refForm="'stationAddRefForm'"
      :title="(dialogTitle = $t('button.addAirCompressionStation'))"
      :dialogAddAir="dialogAdd"
      :airform="airform"
      :custOption="custOption"
      :airoptions="airoptions"
      :subButtonAuth="hasCreateAuth"
      @onSubBtn="addDeviceStation"
      @dialogVisibleEvent="showDialog"
    >
    </station-dialog>
    <station-dialog
      ref="stationEditRef"
      :refForm="'stationEditRefForm'"
      :title="(dialogTitle = $t('button.editAirCompressionStation'))"
      :dialogAddAir="dialogEdit"
      :airform="airform"
      :custOption="custOption"
      :airoptions="airoptions"
      :subButtonAuth="hasUpdateAuth"
      @onSubBtn="updateDeviceStation"
      @dialogVisibleEvent="showEditDialog"
    >
    </station-dialog>
  </div>
</template>

<script>
import {
  CreateMenu,
  addDeviceStation,
  getDeviceStationList,
  deleteDeviceStation,
  updateDeviceStation,
  getDeviceStationById,
  getAllCustomer,
  authOperationCheck,
} from "../../api/api";

import { mapState } from "vuex";
import stationDialogComponent from "../../components/content/maintabber/DeviceStationDialog";

export default {
  name: "index",
  components: {
    "station-dialog": stationDialogComponent,
  },
  data() {
    return {
      dialogTitle: "",
      dialogAdd: false,
      dialogEdit: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      formsearch: {},
      tableData1: [],
      custOption: [],
      airoptions: [],
      airform: {
        stationName: "",
        address: "",
        customerName: "",
        customerId: "",
        // deviceTable: {
        //   type: Array,
        //   default: function () {
        //     return [];
        //   },
        // },
      },
    };
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
    navselected: (state) => state.adminleftnavnum,
  }),
  created: function () {
    this.authOperation("Station");
  },
  async mounted() {
    this.getTableList();
    this.getCustOption();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
    },
    getTableList() {
      let that = this;
      getDeviceStationList(that.formsearch).then((res) => {
        console.log(res);
        let data = res.result;
        that.tableData1 = data;
      });
    },
    getCustOption() {
      let that = this;
      getAllCustomer().then((res) => {
        console.log(res);
        let data = res.result;
        that.custOption = data;
        for (let index = 0; index < data.length; index++) {
          that.custOption[index].customerName =
            data[index].customerCode +
            "_" +
            data[index].customerName +
            "_" +
            data[index].companyType +
            "_" +
            data[index].manageCpName;
        }
      });
    },
    addDeviceStation() {
      let that = this;
      addDeviceStation(that.airform)
        .then((res) => {
          console.log(res);
          that.dialogAdd = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.saveSuccess"),
            type: "success",
          });
          that.getTableList();
          that.airform = {
            stationName: "",
            address: "",
            customerName: "",
            customerId: "",
          };
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    getDeviceStationById(e) {
      let that = this;
      let data = { id: e };
      getDeviceStationById(data).then((res) => {
        console.log(res);
        that.airform = res.result;
      });
    },
    deleteDeviceStation(e) {
      let that = this;
      let data = { id: e };
      deleteDeviceStation(data)
        .then((res) => {
          that.$message({
            showClose: true,
            message: this.$t("tips.deleteSuccess"),
            type: "success",
          });
          that.getTableList();
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    updateDeviceStation() {
      let that = this;
      updateDeviceStation(that.airform).then((res) => {
        that.dialogEdit = false;
        that.$message({
          showClose: true,
          message: that.$t("tips.updateSuccess"),
          type: "success",
        });
        that.getTableList();
      });
    },
    // addBuildRow() {
    //   var list = {
    //     ssn: "",
    //   };
    //   this.airform.deviceTable.push(list);
    // },
    // delBuildRow(index, row) {
    //   this.airform.deviceTable.splice(index, 1);
    // },
    openNotice() {
      this.$notify({
        title: "警告",
        message: "这是一条警告的提示消息",
        type: "warning",
      });
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    handleAccredit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    onSubmit() {},

    showDialog(visible) {
      if (visible) {
        this.airform = {
          stationName: "",
          address: "",
          customerName: "",
          customerId: "",
        };
        if (this.$refs.stationAddRef.$refs.stationAddRefForm != undefined) {
          this.$refs.stationAddRef.$refs.stationAddRefForm.resetFields();
        }
      }
      this.dialogAdd = visible;
    },
    showEditDialog(visible, id) {
      this.dialogEdit = visible;
      if (visible) {
        this.getDeviceStationById(id);
        if (this.$refs.stationEditRef.$refs.stationEditRefForm != undefined) {
          this.$refs.stationEditRef.$refs.stationEditRefForm.resetFields();
        }
      } else {
        this.airform = {
          stationName: "",
          address: "",
          customerName: "",
          customerId: "",
        };
      }
    },
    resetKeyword() {
      this.formsearch = {};
    },
  },
};
</script>

<style>
</style>
